import { Schedule } from '../config/types/customerResponse';

export const dedupeSchedules = (schedules: Schedule[] | undefined) => {
	if(schedules === undefined) return [];
	const seen: Record<number, boolean> = {};
	return schedules.filter((item) => {
		if (seen[item.numberOfPayments]) return false;
		seen[item.numberOfPayments] = true;
		return true;
	});
}
